import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "supportFilled"
const SupportFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C13.191 1.5 14.37 1.756 15.466 2.251 16.562 2.747 17.554 3.471 18.386 4.38 19.22 5.287 19.877 6.362 20.324 7.54Q20.491 7.983 20.618 8.439H20.625C21.35 8.438 21.938 9.025 21.938 9.75V14.25C21.938 14.975 21.35 15.563 20.625 15.563H20.618Q20.49 16.017 20.323 16.46C19.876 17.638 19.22 18.713 18.387 19.62 17.554 20.53 16.562 21.254 15.466 21.749 14.369 22.245 13.19 22.5 12 22.5 11.586 22.5 11.25 22.164 11.25 21.75S11.586 21 12 21C12.975 21 13.943 20.79 14.848 20.381 15.754 19.971 16.581 19.371 17.281 18.607 17.98 17.844 18.539 16.934 18.92 15.928Q18.99 15.748 19.05 15.562H18.168C16.937 17.693 14.637 19.126 12 19.126S7.063 17.692 5.83 15.563H3.376C2.65 15.563 2.063 14.975 2.063 14.25V9.75C2.063 9.025 2.65 8.438 3.375 8.438H3.382Q3.51 7.98 3.677 7.54C4.124 6.362 4.78 5.287 5.613 4.38 6.446 3.47 7.438 2.746 8.534 2.25 9.631 1.756 10.81 1.5 12 1.5M14.318 13.503C14.16 13.993 13.85 14.419 13.433 14.722 13.016 15.024 12.515 15.188 12 15.188S10.984 15.024 10.567 14.722C10.151 14.419 9.841 13.992 9.682 13.502L8.612 13.852C8.844 14.566 9.297 15.19 9.906 15.632S11.248 16.312 12 16.312 13.485 16.075 14.094 15.633 15.156 14.566 15.388 13.851zM9.188 9.375C8.67 9.375 8.25 9.795 8.25 10.313 8.25 10.83 8.67 11.25 9.188 11.25 9.705 11.25 10.125 10.83 10.125 10.313S9.705 9.375 9.188 9.375M14.811 9.375C14.296 9.375 13.876 9.795 13.876 10.313 13.875 10.83 14.295 11.25 14.813 11.25 15.33 11.25 15.75 10.83 15.75 10.313S15.33 9.375 14.813 9.375M12 3C11.025 3 10.057 3.21 9.152 3.619 8.246 4.029 7.419 4.629 6.719 5.393 6.02 6.156 5.461 7.066 5.08 8.072Q5.01 8.252 4.95 8.438H5.832C7.063 6.308 9.363 4.874 12 4.874S16.937 6.308 18.17 8.438H19.05Q18.99 8.254 18.92 8.072C18.54 7.066 17.98 6.156 17.28 5.392 16.582 4.63 15.755 4.029 14.849 3.62 13.943 3.209 12.975 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SupportFilledIcon
